import React from "react";
import { Label } from "@/components/ui/label";
import { vehicleTypes } from "./constants";

export function VehicleSelector({ vehicleType, setVehicleType }) {
  return (
    <div className="bg-card border border-border p-6 space-y-4">
      <Label className="font-semibold text-base">Choose Vehicle</Label>
      <div className="grid grid-cols-3 gap-3">
        {vehicleTypes.map((vehicle) => (
          <button
            key={vehicle.id}
            type="button"
            onClick={() => setVehicleType(vehicle.id)}
            className={`p-4 border-2 transition-all text-center ${
              vehicleType === vehicle.id 
                ? "border-accent bg-accent/5" 
                : "border-border hover:border-accent/50"
            }`}
            data-testid={`vehicle-${vehicle.id}`}
          >
            <div className={`w-12 h-12 ${vehicle.color} flex items-center justify-center mx-auto mb-2`}>
              <vehicle.icon className="w-6 h-6 text-white" />
            </div>
            <p className="font-bold">{vehicle.name}</p>
            <p className="text-xs text-muted-foreground">{vehicle.description}</p>
            <p className="text-xs text-accent mt-1">~{vehicle.eta}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
